import { Injectable } from '@angular/core';
import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

@Injectable({ providedIn: 'root' })
export class PhoneService {

  format(value: string, countryCode: string): string {
    const phone = parsePhoneNumberFromString(value, countryCode as CountryCode);
    return phone ? phone.formatInternational() : value;
  }

  isValid(value: string, countryCode: string): boolean {
    const phone = parsePhoneNumberFromString(value, countryCode as CountryCode);
    return phone ? phone.isValid() : false;
  }
}